/* eslint no-console:off */
/* eslint no-class-assign:off */

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Hammer from 'react-hammerjs';
import * as actions from '../actions';
import { getVisibleHappenings, getIsHappeningsFetching } from '../reducers';
import Happenings from '../components/happenings/Happenings';
import Loading from '../components/Loading';

class Home extends Component {
  constructor() {
    super();
    this.toggleHappenings = this.toggleHappenings.bind(this);
  }
  componentDidMount() {
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    const { edition } = this.props;
    if (edition !== prevProps.edition) {
      this.fetchData();
    }
  }
  fetchData() {
    const { edition, fetchHappenings } = this.props;
    fetchHappenings(edition);
  }
  toggleHappenings() { // eslint-disable-line
    const body = document.body;
    body.classList.contains('highlightsVisible') ? // eslint-disable-line
      body.classList.remove('highlightsVisible') :
      body.classList.add('highlightsVisible');
  }
  handleSwipe(event) { //eslint-disable-line
    if (document.querySelector('.main-wrapper').classList.contains('is-front')) {
      return;
    }
    if (event.deltaX > 0) {
      document.body.classList.remove('highlightsVisible');
    } else {
      document.body.classList.add('highlightsVisible');
    }
  }
  render() {
    const { isFetching, happenings, lang, ...rest } = this.props;
    if (isFetching && !happenings.length) {
      return (
        <div className={`${this.front ? 'is-front' : 'inner'} ${this.foldClass} main-wrapper`}>
          <Loading />
        </div>
      );
    }
    return (
      <Hammer onSwipe={this.handleSwipe} direction="DIRECTION_HORIZONTAL">
        <Happenings
          lang={lang}
          toggleHappenings={this.toggleHappenings}
          {...rest}
          happenings={happenings}
        />
      </Hammer>);
  }
}

Home.propTypes = {
  lang: PropTypes.string.isRequired,
  fetchHappenings: PropTypes.func.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  isFetching: PropTypes.bool.isRequired,
  happenings: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { edition } = ownProps;
  return {
    happenings: getVisibleHappenings(state, edition),
    isFetching: getIsHappeningsFetching(state),
    edition,
  };
};

Home = connect(
  mapStateToProps,
  actions,
)(Home);

export default Home;



// WEBPACK FOOTER //
// ./js/containers/Home.js